import "./style.scss";
import { useState } from "react";
import AOPConfig from "./AOPConfig/AOPConfig";
import AOPPrev from "./AOPPrev/AOPPrev";
import { AOPPolandPaymentConfirmationData } from "@/src/types/admissionOffice";

const AOPPolandPaymentConfirmationLayout = () => {
  const [isPrevReady, setIsPrevReady] = useState<boolean>(false);
  const [dataForGeneration, setDataForGeneration] = useState<AOPPolandPaymentConfirmationData>({
    currentDate: "",
    fullName: "",
    dateOfBirth: "",
    nationality: "",
    course: "",
    userOffice: "01",
    whose_doc: "",
    title: "",
    duration: "",
    mediumOfInstruction: "",
    coursePrefix: "",
    payment_header: [],
    payment_footer: [],
  });

  const [bodyForPrev, setBodyForPrev] = useState<AOPPolandPaymentConfirmationData>({
    currentDate: "",
    fullName: "",
    dateOfBirth: "",
    nationality: "",
    course: "",
    userOffice: "01",
    whose_doc: "",
    title: "",
    duration: "",
    mediumOfInstruction: "",
    coursePrefix: "",
    payment_header: [],
    payment_footer: [],
  });

  return (
    <>
      <div className="container admission-office-page">
        <AOPConfig
          dataForGeneration={dataForGeneration}
          setDataForGeneration={setDataForGeneration}
          setBodyForPrev={setBodyForPrev}
          setIsPrevReady={setIsPrevReady}
        />
        <AOPPrev bodyForPrev={bodyForPrev} isPrevReady={isPrevReady} />
      </div>
    </>
  );
};

export default AOPPolandPaymentConfirmationLayout;
